import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { CardContent, CardTitle, Image } from '@thd-olt-component-react/core-ui';
import { clickEvent, impressionEvent } from '../publisher';
import { cardImageUrl } from '../plccUtils';
import './error.style.scss';

const Error = ({ redirectToCiti }) => {
  useEffect(() => {
    impressionEvent('plcc-unable to display');
  }, []);

  return (
    <>
      <CardTitle title="My Home Depot Credit Card" className="u-width-100" />
      <CardContent className="u-width-100">
        <div className="plcc-error">
          <div className="plcc-error-flex">
            <p className="u__text-align--center u__bold">
              <Image
                src="https://assets.thdstatic.com/images/v1/info.svg"
                className="plcc-error-info-icon"
                alt="info icon"
                width="17"
                height="17"
              />
              Cannot Display Information
            </p>
            <p className="u__text-align--center plcc-error-flex-p-line-height">
              We’re having trouble accessing your account information.
            </p>
          </div>
          <div className="u__bold u__text-align--center">
            Still Need to Pay & Manage Your Card?
          </div>
          <div className="plcc-error-card u__border--bottom">
            <Image
              src={cardImageUrl.PLCN_HOMEDEPOT}
              className="u--paddingRight"
              alt="Credit Card Icon"
              height="31"
              width="50"
            />
            <div className="u--paddingLeft">
              <p className="u__bold">Consumer Credit</p>
              <div className="plcc-error-link-flex">
                <button
                  className="u__default-link plcc-pay-and-manage-link"
                  onClick={() => {
                    clickEvent('plcc-unable to display go to citibank');
                    redirectToCiti('PLCN_HOMEDEPOT');
                  }}
                  type="button"
                >
                  Pay & Manage
                </button>
                <a className="plcc-phone-number" href="tel:1-866-875-5488">
                  1-866-875-5488
                </a>
              </div>
            </div>
          </div>
          <div className="plcc-error-card u__border--bottom">
            <Image
              src={cardImageUrl.PLNP_HOMEDEPOT}
              className="plcc-card-img u--paddingRight"
              alt="Credit Card Icon"
              height="31"
              width="50"
            />
            <div className="u--paddingLeft">
              <p className="u__bold">Commercial Credit</p>
              <div className="plcc-error-link-flex">
                <button
                  className="u__default-link plcc-pay-and-manage-link"
                  onClick={() => {
                    clickEvent('plcc-unable to display go to citibank');
                    redirectToCiti('PLNP_HOMEDEPOT');
                  }}
                  type="button"
                >
                  Pay & Manage
                </button>
                <a className="plcc-phone-number" href="tel:1-866-875-5490">
                  1-866-875-5490
                </a>
              </div>
            </div>
          </div>
          <div className="plcc-error-card">
            <Image
              src={cardImageUrl.PLCR_HOMEDEPOT}
              className="u--paddingRight"
              alt="Credit Card Icon"
              height="31"
              width="50"
            />
            <div className="u--paddingLeft">
              <p className="u__bold">Commercial Revolving Credit</p>
              <div className="plcc-error-link-flex">
                <button
                  className="u__default-link plcc-pay-and-manage-link"
                  onClick={() => {
                    clickEvent('plcc-unable to display go to citibank');
                    redirectToCiti('PLCR_HOMEDEPOT');
                  }}
                  type="button"
                >
                  Pay & Manage
                </button>
                <a className="plcc-phone-number" href="tel:1-866-875-5489">
                  1-866-875-5489
                </a>
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    </>
  );
};

Error.propTypes = {
  redirectToCiti: PropTypes.func.isRequired,
};

export default Error;
